import React, { useState } from "react";
import AppStateHandler, {
  useAppState,
} from "src/StateHandlers/AppStateHandler";
import { Link, useRouteMatch } from "react-router-dom";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import NotificationsList from "../NotificationsList/NotificationsList";
import useApiFetch from "src/Hooks/Shared/useApiFetch";
import EndPoints from "src/Constants/EndPoints";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import { useTranslation } from "react-i18next";

function UserNavBar({ setModalVisibility, setSearch, search }: any) {
  const [{ user }] = useAppState();
  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const { path } = useRouteMatch();
  const { t, i18n } = useTranslation();

  const { data: countResponse } = useApiFetch(
    [`${EndPoints.notificationsCount}?subId=${user?.username}`],
    {}
  );
  const count = countResponse?.data?.Count ?? 0;
  const user_name = user?.attributes?.name;
  const openCreatePostModal = (e: any) => {
    e.preventDefault();
    setModalVisibility(true);
  };
  const logout = () => {
    AppStateHandler.logout();
  };

  return (
    <div className="top-bar" id="top-bar">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-md-8 col-xl-9" style={{ zIndex: 1000 }}>
            <div className="col_selector d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div className="" style={{ zIndex: 1000 }}>
                  <div className={`m${i18n.dir()==='rtl'?'l':'r'}-2 m${i18n.dir()==='rtl'?'l':'r'}-sm-4 top_logo`}>
                    <Link
                      className="d-inline-block"
                      style={{ width: 60 }}
                      to="/home"
                    >
                      <img
                        src="assets/images/logo.svg"
                        className="img-fluid"
                        alt="logo"
                      />
                    </Link>
                  </div>
                </div>
                <form className={`m${i18n.dir()==='rtl'?'l':'r'}-2 top_form`}>
                  <div className="form-group my-2 d-flex align-items-center position-relative home_search">
                    <i
                      className="fa fa-bars mr-2 mr-sm-3 fz20 text-secondary d-md-none"
                      onClick={AppStateHandler.toggleSidebar}
                      aria-hidden="true"
                    ></i>
                    <VisibilityToggle visible={path === "/home"}>
                      <input
                        value={search}
                        type="text"
                        className="form-control custom_input border-0 pr-5"
                        placeholder={t("Search in Houmti")}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <i className={` fa fa-search ${i18n.dir()==='rtl'?'fa-search-rtl':'fa-search-ltr'}`} aria-hidden="true"></i>
                    </VisibilityToggle>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-4 col-xl-3">
            <div className="d-flex align-items-center justify-content-end mt-4 mt-md-0">
              <div className="user_panel align-items-center">
                <div className={`user_img ${i18n.dir()==='rtl'?'ml-3':'mr-3'}`}>
                  <img
                    src={
                      user?.attributes?.picture ??
                      "/assets/images/profile-camera.png"
                    }
                    alt=""
                  />
                </div>
                <div className="user_details">
                  <div className="user_name">
                    <h6>
                      {user_name.length > 25
                        ? user_name.substr(0, 25) + "..."
                        : user_name}
                    </h6>
                  </div>
                </div>
              </div>
              <VisibilityToggle visible={path === "/home"}>
                <a
                  href="/"
                  className={`d-inline-block ${i18n.dir()==='rtl'?'mr-4':'ml-4'}`}
                  onClick={openCreatePostModal}
                >
                  <i
                    className="fa fa-plus fz18 top_icon"
                    title="Plus"
                    aria-hidden="true"
                  ></i>
                </a>
              </VisibilityToggle>
              <div className={`slider_down_arrow position-relative ${i18n.dir()==='rtl'?'mr-3':'ml-3'} notification_part`}>
                <i
                  className="fa fa-bell fz18 top_icon"
                  title="Notifications"
                  aria-hidden="true"
                ></i>
                {count ? <span className="badge">{count}</span> : ""}
                <NotificationsList />
              </div>
              <div className={`slider_down_arrow position-relative ${i18n.dir()==='rtl'?'mr-3':'ml-3'} notification_part`}>
                <i
                  className="fa fa-sort-desc fz18 top_icon"
                  title={t("Account")}
                  aria-hidden="true"
                ></i>
                <div className={`user_actions ${i18n.dir()==='rtl'?'user_actions_posRTL':'user_actions_posLTR'}`}>
                  <ul className={`list-unstyled  ${i18n.dir()==='rtl'?'text-right Almaraibold pr-0':'text-left poppinsbold'} mb-0 px-2`}>
                    <li>
                      <Link className="py-4 px-2" to="/my-profile">
                        <img
                          src="assets/images/user.png"
                          className= {`${i18n.dir()==='rtl'?'ml-4':'mr-4'}`}
                          alt=""
                        />
                        {t("Profile")}
                      </Link>
                    </li>
                    <li>
                      <Link className="py-4 px-2" to="/my-posts">
                        <img
                          src="assets/images/mypost.png"
                          className={`${i18n.dir()==='rtl'?'ml-4':'mr-4'}`}
                          alt=""
                        />
                        {t("My Posts")}
                      </Link>
                    </li>
                    <li>
                      <Link className="py-4 px-2" to="/hidden-posts">
                        <img
                          src="assets/images/hidden-post.png"
                          className={`${i18n.dir()==='rtl'?'ml-3':'mr-3'}`}
                          alt=""
                        />
                        {t("Hidden Posts")}
                      </Link>
                    </li>
                    <li>
                      <Link className="py-4 px-2" to="/bookmarks">
                        <img
                          src="assets/images/bookmark.png"
                          className={`${i18n.dir()==='rtl'?'ml-4':'mr-4'}`}
                          alt=""
                        />
                        {t("Bookmarks")}
                      </Link>
                    </li>
                    <li>
                      <Link className="py-4 px-2" to="/settings">
                        <img
                          src="assets/images/settings.png"
                          className={`${i18n.dir()==='rtl'?'ml-4':'mr-4'}`}
                          alt=""
                        />
                        {t("Settings")}
                      </Link>
                    </li>
                    <li>
                      <a
                        className="py-4 px-2"
                        href="/"
                        onClick={(e) => {
                          e.preventDefault();
                          setConfirmModal(true);
                        }}
                      >
                        <img
                          src="assets/images/logout.png"
                          className={`${i18n.dir()==='rtl'?'ml-4':'mr-4'}`}
                          alt=""
                        />
                        {t("Logout")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {confirmModal ? (
        <ConfirmModal
          showModal={confirmModal}
          setModalVisibility={setConfirmModal}
          confirmAction={logout}
          ConfirmationText={"Are you sure?"}
          CancelBtnText={"Cancel"}
          ConfirmBtnText={"Yes"}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default React.memo(UserNavBar);
